var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMegaphone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 682.66669 682.66669",
    fill: "none",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "megaphoneClip",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,512 H 512 V 0 H 0 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333333,0,0,-1.3333333,0,682.66667)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#megaphoneClip)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(104.8663,152.6219)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 48.759,28.151 -14.48,137.683 -63.239,109.533 C -93.485,92.07 -103.848,53.394 -86.386,23.147 h 10e-4 C -68.923,-7.1 -30.247,-17.463 0,0 Z",
    stroke: "currentColor",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(200.5441,413.6095)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 49.832,55.779 138.335,-239.602 -235.086,-49.014 -63.239,109.533 50.203,56.194",
    stroke: "currentColor",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(418.406,221.8298)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v 0 c 10.397,6.003 13.96,19.298 7.957,29.695 l -138.335,239.602 c -6.003,10.398 -19.298,13.96 -29.695,7.957 v 0 c -10.397,-6.003 -13.959,-19.298 -7.957,-29.695 L -29.695,7.957 C -23.692,-2.441 -10.397,-6.003 0,0 Z",
    stroke: "currentColor",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(108.2892,154.5981)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 17.516,-30.339 c 4.944,-8.563 15.895,-11.497 24.458,-6.553 l 64.812,37.419 c 8.563,4.944 11.497,15.894 6.553,24.458 l -6.561,11.364",
    stroke: "currentColor",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(206.6205,150.2439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 52.967,-91.741 13.279,-8.888 c 5.879,-3.935 5.59,-12.672 -0.537,-16.21 l -38.32,-22.124 c -4.569,-2.637 -10.41,-1.072 -13.048,3.497 l -62.244,107.809",
    stroke: "currentColor",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(406.3156,399.6855)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 64.607,37.301",
    stroke: "currentColor",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(382.4648,436.832)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 30.782,53.317",
    stroke: "currentColor",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(433,360.4569)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 48.685",
    stroke: "currentColor",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(501.9849,454.9202)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V 0",
    stroke: "currentColor",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(170.5663,380.0541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V 0",
    stroke: "currentColor",
    strokeWidth: 30,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegaphone);
export default __webpack_public_path__ + "static/media/megaphone.a797cf1f.svg";
export { ForwardRef as ReactComponent };